import PDFDocument from "pdfkit/js/pdfkit.standalone.js";

import { ConditionReportPDFGenerator } from './condition-report-pdf-generator';

/**
 * This file defines extension methods for the PDFDocument class
 * from pdfKit.
 * 
 * The purpose is to lighten the PDFGenerator class and to make custom
 * methods accessible with the same syntax as the original one 
 * (ex : boldText() ~ text())
 */

PDFDocument.prototype.boldText = function (textValue, options?): void {
    this.save()
    this
        .font(ConditionReportPDFGenerator.BOLD_FONT)
        .fontSize(ConditionReportPDFGenerator.BODY_TEXT_FONT_SIZE)
        .text(textValue, options)
    this.restore()
}

PDFDocument.prototype.sectionTitle = function (sectionTitle: string, underlineOffset: number = 50) {
    this.save()
    this.regularText("", { continued: false })
    this.font(ConditionReportPDFGenerator.BOLD_FONT)
    this.moveDown();
    this.fontSize(ConditionReportPDFGenerator.SECTION_FONT_SIZE)
        .fill("black")
        .text(sectionTitle, {
            align: 'left',
            weight: 'bold'
        });
    this.save()
        .moveTo(this.x, this.y)
        .lineTo(this.page.width - ConditionReportPDFGenerator.DOCUMENT_MARGIN, this.y)
        .stroke();
    this.restore()
}

PDFDocument.prototype.softSeparationLine = function () {
    const lineOffset = 75;
    this.save()
        .moveTo(this.x + lineOffset, this.y)
        .lineTo(this.page.width - lineOffset - ConditionReportPDFGenerator.DOCUMENT_MARGIN, this.y)
        .stroke('darkgrey');
    this.restore()
}

PDFDocument.prototype.regularText = function (text: string, options?: any) {
    this.save()
    this
        .fill("black")
        .font(ConditionReportPDFGenerator.REGULAR_FONT)
        .fontSize(ConditionReportPDFGenerator.BODY_TEXT_FONT_SIZE)
        .text(text, options)
    this.restore()
}

PDFDocument.prototype.dataWithBoldLabel = function (label: string, value: string, options?: any) {
    if (value || (options && options.displayIfNoValue)) {
        this.save()
        this.boldText(label + " ", { ...options, continued: true })
        this.regularText(value || "...", { paragraphGap: 8 })
        this.restore()
    }
}

/**
 * Resets the continue property of a paragraph
 */
PDFDocument.prototype.breakContinue = function () {
    this.regularText("", { continue: false })
    this.moveUp()
}

/**
 * Find where to split the text in 2 using binary search in a way where the first half is the closest to maxHeight without being superior
 * @returns The index at which the text can be split. -1 if the search failed
 */
PDFDocument.prototype.getTextAfterHeight = function (text: string, maxHeight: number, options?: any): number {
    //const heightOfText = this.heightOfString(text, options)
    let lowLimit = 0
    let highLimit = text.length - 1

    //let previousValidHeight: number | null = null
    let lastValidResult: number = -1

    while(lowLimit <= highLimit) {
        const middle = Math.floor((lowLimit+highLimit)/2)
        const height = this.heightOfString(text.substring(0, middle), options)

        if(height < maxHeight) {
            lowLimit = middle+1
            //previousValidHeight = height
            lastValidResult = middle
        }
        else if(height > maxHeight) {
            highLimit = middle-1 
        }
        else {
            return middle
        }
    }

    return lastValidResult
}